import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import Flex from "../../../DefaultStyles/Flex";
import Loader from "../../../DefaultStyles/Loader";
import DefaultModalLayout, {
  ModalFixedBox,
} from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../pages/Login";
import dayjs from "dayjs";
import Blank from "../../../DefaultStyles/Blank";
import { Input } from "../../../Input/Input";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalRowContentContainer } from "../../AlimTalk/AlimTalkModal";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import { getSubscriptionNameV3 } from "../../../../ApiTS/ServiceDatasTS_V3";
import { getStateStr } from "../../../../pages/Party/Lingokids";

interface LingoKidsUpdateModalProps extends DefaultModalCommonProps {
  code: string;
  partyid: number;
  state: number;
  id: string;
  confirmEvent: () => void;
  closeEvent: () => void;
}

export default function LingoKidsUpdateModal({
  closeEvent,
  confirmEvent,
  code,
  partyid,
  state,
  id,
}: LingoKidsUpdateModalProps) {
  const auth = useRecoilValue(authType);
  const [updateBtnClick, setUpdateBtnClick] = useState(false);

  const options: OptionType[] = [
    { value: "0", label: "할당 전", isDisabled: state >= 0 ? true : false },
    { value: "1", label: "할당 함", isDisabled: state !== 0 ? true : false },
    { value: "2", label: "정상사용", isDisabled: state !== 1 ? true : false },
    {
      value: "3",
      label: "기사용(타계정)",
      isDisabled: state < 2 ? true : false,
    },
    {
      value: "4",
      label: "만료 코드",
      isDisabled: state < 2 ? true : false,
    },
    {
      value: "5",
      label: "무효 코드",
      isDisabled: state < 2 ? true : false,
    },
    {
      value: "6",
      label: "기사용(자계정)",
      isDisabled: state < 2 ? true : false,
    },
  ];

  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: String(state),
    label: getStateStr(state),
  });

  interface Party {
    servsubsid: number;
    partyid: string;
    grade: number;
    // add other properties if needed
  }
  const [PartyList, setPartyList] = useState<Party[]>([]);
  const [SelectedParty, setSelectedParty] = useState<OptionType>({
    value: String(partyid) ?? "",
    label: partyid !== 0 ? String(partyid) : "선택",
  });

  const {
    response: partyListResponse,
    error: partyListError,
    loading: partyListLoading,
  } = useApi({
    method: "get",
    url: `party?servsubsid=31000&state=1&page=0&size=100`,
  });

  const { response, loading, error } = useApi({
    method: "post",
    url: updateBtnClick ? `party/ringcode` : undefined,
    data: {
      id: id,
      partyid: Number(SelectedParty?.value),
      state: Number(dropDownValue?.value),
    },
  });

  useEffect(() => {
    if (response?.status === 200) {
      toast.error("변경하였습니다.");
      confirmEvent();
    }
  }, [response]);

  useEffect(() => {
    if (error || partyListError) {
      toast.error(error?.data ?? "로그 확인에 실패하였습니다.");
      setUpdateBtnClick(false);
    }
  }, [error, partyListError]);

  //   파티 리스트 받아오기
  useEffect(() => {
    if (
      partyListResponse?.status === 200 ||
      partyListResponse?.status === 201
    ) {
      setPartyList(partyListResponse?.data?.items);
      //   toast.success("파티 리스트 받아오기 완료.");
    }
  }, [partyListResponse]);

  console.log(id, SelectedParty.value, dropDownValue.value);

  return (
    <>
      <DefaultModalLayout
        modalTitle="링고키즈 쿠폰 정보 수정"
        closeEvent={() => closeEvent()}
        confirmEvent={() => setUpdateBtnClick(true)}
        isMediumModal={true}
        confirmDisabled={
          dropDownValue?.label === "선택" || SelectedParty?.label === "선택"
        }
      >
        <ModalRow>
          <ModalLabel>ID</ModalLabel>

          <ModalRowContentContainer>
            <ModalFixedBox>{id}</ModalFixedBox>
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>CODE</ModalLabel>

          <ModalRowContentContainer>
            <ModalFixedBox>{code}</ModalFixedBox>
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>파티 ID</ModalLabel>
          <ModalRowContentContainer>
            {partyid !== 0 ? (
              <ModalFixedBox>{partyid}</ModalFixedBox>
            ) : (
              <DropDown
                dropdownValue={SelectedParty}
                setDropDownValue={setSelectedParty}
                optionList={PartyList.map((party) => ({
                  value: String(party.partyid),
                  label: `${String(party.partyid)}`,
                }))}
                // boxWidth={0}
              />
            )}
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow>
          <ModalLabel>상태</ModalLabel>

          <ModalRowContentContainer>
            <DropDown
              isDisabled={false}
              setDropDownValue={setDropDownValue}
              dropdownValue={dropDownValue}
              optionList={options}
              // boxWidth={180}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <Blank marginHeight={20} blankHeight={20} />
      </DefaultModalLayout>

      {loading && <Loader />}
    </>
  );
}

const Column = styled.div`
  width: 250px;
`;

const Row = styled.div`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`;
const ValueContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`;
